<main class="flex min-h-full w-full min-w-0 flex-col py-8 [padding-inline:var(--shell-pad-x)]">
  <app-ui-page-header
    [title]="module().label"
    [subtitle]="module().description"
    density="compact"
  >
    <span meta appBadge tone="neutral" size="xs">{{ module().status }}</span>
  </app-ui-page-header>
  <span class="sr-only">{{ module().eyebrow }}</span>

  <app-ui-empty-state
    class="mt-8"
    title="Rota preparada"
    description="Esta área já faz parte da navegação principal. A tela final deve seguir o domínio documentado antes de conectar contratos, dados e ações."
  >
    <a actions appButton routerLink="/dashboard" variant="secondary">
      Voltar para Dashboard
    </a>
  </app-ui-empty-state>
</main>
